import Image from 'next/image'
import { FC } from 'react'

import styles from './AdvantageCard.module.scss'

export type WhyCardProps = {
	backgroundImage: string
	alt?: string
	title: string
	subtitle: string
	subtitleColor?: string
}

export const AdvantageCard: FC<WhyCardProps> = ({
	backgroundImage,
	title,
	alt = title,
	subtitle,
	subtitleColor = '#262A2F'
}) => {
	return (
		<article className={styles.card}>
			<Image src={backgroundImage} alt={alt} width={385} height={598} className={styles.backgroundImage} />
			<div className={styles.text}>
				<h3 className={styles.title}>{title}</h3>
				<p className={styles.subtitle} style={{ color: subtitleColor }}>
					{subtitle}
				</p>
			</div>
		</article>
	)
}
